const data = {
  scene: [
    {
      title: "Открытие",
      section: "Лектроий",
      start: new Date("July 8, 2023 11:30"),
      finish: new Date("July 8, 2023 12:00"),
      authors: [
        {
          name: "",
          position: "",
        },
      ],
    },
    {
      section: "Лектроий",
      title: "Психология успеха и счастья в IT",
      start: new Date("July 8, 2023 12:00"),
      finish: new Date("July 8, 2023 13:00"),
      authors: [
        {
          name: "Евгений Идзиковский",
          position: "IT психолог",
        },
      ],
    },
    {
      section: "Лектроий",
      title: "Путь ML Ops",
      start: new Date("July 8, 2023 13:00"),
      finish: new Date("July 8, 2023 14:00"),
      authors: [
        {
          name: "Валерий Никаноров",
          position: "Исполнительный директор, Сбер",
        },
      ],
    },
    {
      section: "Лектроий",
      title: "Игра IT_alias",
      start: new Date("July 8, 2023 14:00"),
      finish: new Date("July 8, 2023 16:00"),
      authors: [
        {
          name: "Амир Утеуов",
          position: "Cтарший разработчик команды медиа-рекомендаций VK",
        },
      ],
    },
    {
      section: "Лектроий",
      title: "Zero shit learning",
      start: new Date("July 8, 2023 16:00"),
      finish: new Date("July 8, 2023 16:30"),
      authors: [
        {
          name: "Илья Шигобаев",
          position: "exCisco, OZON, SberDevices",
        },
      ],
    },
    {
      title: "Zero-shot classification для неперсонализированных рекомендаций",
      section: "Лектроий",
      start: new Date("July 8, 2023 16:30"),
      finish: new Date("July 8, 2023 17:00"),
      authors: [
        {
          name: "Артем Себало",
          position: "Работа.ру",
        },
      ],
    },
    {
      title: "Как узнать, почему сайт не летает? На стыке QA и SRE",
      section: "Лектроий",
      start: new Date("July 8, 2023 17:00"),
      finish: new Date("July 8, 2023 18:00"),
      authors: [
        {
          name: "Дмитрий Винокуров",
          position: "Perf QA Automation Engineer Miro",
        },
      ],
    },
    {
      title: "Музыкальное выступление",
      section: "Лектроий",
      start: new Date("July 8, 2023 18:00"),
      finish: new Date("July 8, 2023 19:00"),
      authors: [
        {
          name: "GearX2",
          position: "",
        },
      ],
    },
    {
      title:
        "Ошибки мышления, которые притворяются проблемами коммуникации и портят вам жизнь",
      section: "Лектроий",
      start: new Date("July 9, 2023 12:00"),
      finish: new Date("July 9, 2023 13:00"),
      authors: [
        {
          name: "Серафима Чекулаева",
          position: "Руководитель продукта Музыка ВКонтакте",
        },
      ],
    },
    {
      title: "MVP: как определить требования, достаточные для запуска?",
      section: "Лектроий",
      start: new Date("July 9, 2023 13:00"),
      finish: new Date("July 9, 2023 14:00"),
      authors: [
        {
          name: "Константин Семенов",
          position: "Product Owner",
        },
      ],
    },
    {
      title: "Игра DnD",
      section: "Лектроий",
      start: new Date("July 9, 2023 14:00"),
      finish: new Date("July 9, 2023 16:30"),
      authors: [
        {
          name: "Виктор Корейша",
          position: "Руководитель отдела Message Bus OZON",
        },
        {
          name: "Евгений Антонов",
          position: "Технический менеджер Yandex Infrastructure",
        },
        {
          name: "Анастасия Абрашитова",
          position: "Head of repository tools Yandex Infrastructure",
        },
        {
          name: "Андрей Смирнов",
          position: "Frontend Weekend",
        },
        {
          name: "Серафима Чекулаева",
          position: "Руководитель продукта Музыка ВКонтакте",
        },
        {
          name: "Евгений Идзиковский",
          position: "IT психолог",
        },
      ],
    },
    {
      title:
        "Зачем менять, если работает: стратегии обновления устаревших продуктов",
      section: "Лектроий",
      start: new Date("July 9, 2023 16:30"),
      finish: new Date("July 9, 2023 18:00"),
      authors: [
        {
          name: "Василий Алексуткин",
          position:
            "Директор проектов продуктовой лаборатории B2B ПАО «Ростелеком»",
        },
      ],
    },
    {
      title: "Закрытие фестиваля",
      section: "Лектроий",
      start: new Date("July 9, 2023 18:00"),
      finish: new Date("July 9, 2023 19:00"),
      authors: [
        {
          name: "",
          position: "",
        },
      ],
    },
    {
      title: "DJ GyPsyDog",
      section: "Лектроий",
      start: new Date("July 9, 2023 19:00"),
      finish: new Date("July 10, 2023 00:00"),
      authors: [
        {
          name: "DataScientist",
          position: "Который не ходит на конференции, но ездит на фестивали",
        },
      ],
    },
  ],

  1: [
    {
      title: "Менторинг для Team Lead",
      section: "Менторинг",
      start: new Date("July 8, 2023 12:00"),
      finish: new Date("July 8, 2023 13:00"),
      authors: [
        {
          name: "Анастасия Абрашитова",
          position: "Head of repository tools Yandex Infrastructure",
        },
      ],
    },
    {
      title: "Менторинг для iOS",
      section: "Менторинг",
      start: new Date("July 8, 2023 13:00"),
      finish: new Date("July 8, 2023 14:00"),
      authors: [
        {
          name: "Екатерина Батеева",
          position: "iOS OK",
        },
      ],
    },
    {
      title: "Менторинг по Архитектуре",
      section: "Менторинг",
      start: new Date("July 8, 2023 14:00"),
      finish: new Date("July 8, 2023 14:30"),
      authors: [
        {
          name: "Игорь Костяков",
          position: "CTO IBS Dunice",
        },
      ],
    },
    {
      title: "Менторинг по UI/UX",
      section: "Менторинг",
      start: new Date("July 8, 2023 14:30"),
      finish: new Date("July 8, 2023 15:00"),
      authors: [
        {
          name: "Яна Савельева",
          position: "Mentor UI/UX",
        },
      ],
    },
    {
      title: "Менторинг для Product Manager",
      section: "Менторинг",
      start: new Date("July 8, 2023 15:00"),
      finish: new Date("July 8, 2023 16:00"),
      authors: [
        {
          name: "Екатерина Михалис",
          position: "Lead CareerCentre ProductStar, Org Kastry Fest",
        },
      ],
    },
    {
      title: "Менторинг по Аналитике",
      section: "Менторинг",
      start: new Date("July 8, 2023 16:00"),
      finish: new Date("July 8, 2023 17:00"),
      authors: [
        {
          name: "Ольга Мазур",
          position: "Head of Business Analysis — Samokat.tech",
        },
      ],
    },
    {
      title: "Менторинг для Python",
      section: "Менторинг",
      start: new Date("July 8, 2023 17:00"),
      finish: new Date("July 8, 2023 18:00"),
      authors: [
        {
          name: "Алексей Шкиль",
          position: "TL Back / Python dev, ментор Solvery",
        },
      ],
    },
    {
      title: "Игра Architectural katas",
      section: "Архитектура",
      start: new Date("July 9, 2023 12:00"),
      finish: new Date("July 9, 2023 15:00"),
      authors: [
        {
          name: "Глеб Гончаров",
          position: "СберМаркет",
        },
      ],
    },
    {
      title: "Круглый стол: «Так исторически сложилось»",
      section: "Архитектура",
      start: new Date("July 9, 2023 15:00"),
      finish: new Date("July 9, 2023 16:00"),
      authors: [
        {
          name: "Александр Поломодов",
          position: "Тинькофф",
        },
        {
          name: "Алексей Тарасов",
          position: "Тинькофф Инвестиции",
        },
        {
          name: "Константин Хицко",
          position: "VK",
        },
        {
          name: "Наталья Крапкина",
          position: "Организатор ProIT Fest",
        },
      ],
    },
    {
      title:
        "Дайте совет. Участники приносят свои кейсы на ревью ведущих архитекторов",
      section: "Архитектура",
      start: new Date("July 9, 2023 16:00"),
      finish: new Date("July 9, 2023 18:00"),
      authors: [
        {
          name: "Олег Чирухин",
          position: "Axiom JDK",
        },
        {
          name: "Филипп Дельгядо",
          position: "lekton.io",
        },
        {
          name: "Юрий Бабак",
          position: "Avito",
        },
        {
          name: "Александр Поломодов",
          position: "Тинькофф",
        },
        {
          name: "Виктор Корейша",
          position: "OZON",
        },
        {
          name: "Алексей Шарапов",
          position: "VK",
        },
        {
          name: "Игорь Костяков",
          position: "IBS Dunice",
        },
        {
          name: "Алексей Тарасов",
          position: "Тинькофф Инвестиции",
        },
        {
          name: "Виктор Лапин",
          position: "Advantum",
        },
        {
          name: "Андрей Парамонов",
          position: "DODO Engineering",
        },
        {
          name: "Константин Хицко",
          position: "VK",
        },
      ],
    },
  ],

  2: [
    {
      title:
        "Интервью: Владимир Шульга, директор департамента разработки Cloud.ru",
      section: "Network",
      start: new Date("July 8, 2023 12:00"),
      finish: new Date("July 8, 2023 13:00"),
      authors: [
        {
          name: "Саша Стародубцев",
          position: "Frontend разработчик Сloud.ru",
        },
      ],
    },
    {
      title: "Интервью: Евгений Идзиковский, IT психолог",
      section: "Network",
      start: new Date("July 8, 2023 13:00"),
      finish: new Date("July 8, 2023 14:00"),
      authors: [
        {
          name: "Михаил Трифонов",
          position: "Старший техлид Cloud.ru",
        },
      ],
    },
    {
      title: "Мастер-класс по питчу / презентации себя",
      section: "Network",
      start: new Date("July 8, 2023 14:00"),
      finish: new Date("July 8, 2023 15:00"),
      authors: [
        {
          name: "Теххи Полонская",
          position: "Founder Брусника",
        },
      ],
    },
    {
      title: "Знакомства: NetWork Zone",
      section: "Network",
      start: new Date("July 8, 2023 15:00"),
      finish: new Date("July 8, 2023 16:00"),
      authors: [
        {
          name: "Кира Кузнецова",
          position: "Release Group Lead, Lesta Games",
        },
      ],
    },
    {
      title: "Обед с Никитой Соболевым",
      section: "Network",
      start: new Date("July 8, 2023 16:00"),
      finish: new Date("July 8, 2023 17:00"),
      authors: [
        {
          name: "Илья Шигобаев",
          position: "exCisco, OZON, SberDevices",
        },
      ],
    },
    {
      title: "Сходка Волков",
      section: "Network",
      start: new Date("July 8, 2023 17:00"),
      finish: new Date("July 8, 2023 18:00"),
      authors: [
        {
          name: "Антон Назаров",
          position: "aka M0rtyMerr",
        },
      ],
    },
    {
      title: "IT Business Dating, Знакомство",
      section: "Dating",
      start: new Date("July 9, 2023 12:00"),
      finish: new Date("July 9, 2023 13:00"),
      authors: [
        {
          name: "Friendly Dating",
          position: "",
        },
      ],
    },
    {
      title: "IT Business Dating, tet-a-tet",
      section: "Dating",
      start: new Date("July 9, 2023 13:00"),
      finish: new Date("July 9, 2023 15:00"),
      authors: [
        {
          name: "Friendly Dating",
          position: "",
        },
      ],
    },
    {
      title: "Expert Dating, знакомство",
      section: "Dating",
      start: new Date("July 9, 2023 15:00"),
      finish: new Date("July 9, 2023 16:00"),
      authors: [
        {
          name: "Solvery + Friendly dating",
          position: "",
        },
      ],
    },
    {
      title: "Expert Dating, tet-a-tet",
      section: "Dating",
      start: new Date("July 9, 2023 16:00"),
      finish: new Date("July 9, 2023 18:00"),
      authors: [
        {
          name: "Solvery + Friendly dating",
          position: "",
        },
      ],
    },
    {
      title: "IT Business Dating, Знакомство",
      section: "Dating",
      start: new Date("July 9, 2023 18:00"),
      finish: new Date("July 9, 2023 22:00"),
      authors: [
        {
          name: "Friendly Dating",
          position: "",
        },
      ],
    },
  ],

  3: [
    {
      title: "Переход из специалиста в продакты и предприниматели",
      desc: "Про изменение mind set и переход на новый уровень ответственности",
      section: "Product",
      start: new Date("July 8, 2023 12:00"),
      finish: new Date("July 8, 2023 13:00"),
      authors: [
        {
          name: "Алексей Мезенцев",
          position: "CPO at itps.com",
        },
      ],
    },
    {
      title: "Re-commerce: новый черный в мире Электроники",
      section: "Product",
      start: new Date("July 8, 2023 13:00"),
      finish: new Date("July 8, 2023 14:00"),
      authors: [
        {
          name: "Илья Грубер",
          position: "Product Unit Lead Avito",
        },
      ],
    },
    {
      title: "Разбор резюме в LIVE режиме. Топ 10 ошибок на собесах",
      section: "Product",
      start: new Date("July 8, 2023 14:00"),
      finish: new Date("July 8, 2023 15:00"),
      authors: [
        {
          name: "Владимир Торопецкий",
          position: "Директор по новым и партнерским продуктам Ростелеком",
        },
      ],
    },
    {
      title:
        "Как стать поли-экспертом, консультируя несколько компаний, и зарабатывать в 5 раз больше, чем в найме",
      section: "Product",
      start: new Date("July 8, 2023 15:00"),
      finish: new Date("July 8, 2023 16:00"),
      authors: [
        {
          name: "Максим Яцкевич",
          position: "Founder Product Psychology",
        },
      ],
    },
    {
      title: "Разбор кейсов в прямом эфире от Дмитрия Торшина",
      section: "Product",
      start: new Date("July 8, 2023 16:00"),
      finish: new Date("July 8, 2023 17:00"),
      authors: [
        {
          name: "Дмитрий Торшин",
          position: "Управляющий партнер Uplift.club",
        },
      ],
    },
    {
      title:
        "Из технарей в бизнес. Кому и зачем это нужно? Ожидание & Реальность",
      section: "Product",
      start: new Date("July 8, 2023 17:00"),
      finish: new Date("July 8, 2023 18:00"),
      authors: [
        {
          name: "Михаил Покидько",
          position:
            "Зам. начальника департамента стратегического развития ИТМО",
        },
      ],
    },
    {
      title: "Девопс в маленькой и в большой компаниях: Юнит и Процесс",
      section: "OOPS",
      start: new Date("July 9, 2023 12:00"),
      finish: new Date("July 9, 2023 12:30"),
      authors: [
        {
          name: "Константин Дипеж",
          position: "Founder DeusOps",
        },
        {
          name: "Александр Крылов",
          position: "TL DevOps",
        },
      ],
    },
    {
      title: "Облака и кубернетесы VS самописные платформы",
      section: "OOPS",
      start: new Date("July 9, 2023 12:30"),
      finish: new Date("July 9, 2023 13:00"),
      authors: [
        {
          name: "Алексей Шарапов",
          position: "CIO VK",
        },
        {
          name: "Иван Буймов",
          position: "Ведущий системный администратор VK",
        },
      ],
    },
    {
      title: "Настоящий Инженер: нужно ли обязательно уметь X чтобы работать Y",
      section: "OOPS",
      start: new Date("July 9, 2023 13:00"),
      finish: new Date("July 9, 2023 14:00"),
      authors: [
        {
          name: "Иван Буймов",
          position: "Ведущий системный администратор VK",
        },
        {
          name: "Константини Дипеж",
          position: "Founder DeusOps",
        },
        {
          name: "Алексей Шарапов",
          position: "CIO VK",
        },
        {
          name: "Александр Крылов",
          position: "TL DevOps",
        },
      ],
    },
    {
      title: "Если не DevOps, то что?",
      section: "OOPS",
      start: new Date("July 9, 2023 14:00"),
      finish: new Date("July 9, 2023 15:00"),
      authors: [
        {
          name: "Серпичев Александр",
          position:
            "Старший менеджер Инфраструктурного консалтинга и ИБ, Axenix",
        },
      ],
    },
    {
      title: "ИТ ландшафт проектируется с другого конца",
      section: "OOPS",
      start: new Date("July 9, 2023 15:00"),
      finish: new Date("July 9, 2023 16:00"),
      authors: [
        {
          name: "Антон Жбанков",
          position: "Архитектор по ИТ инфраструктуре",
        },
      ],
    },
    {
      title: "Мы внедрили все практики безопасной разработки — чтобы что?",
      section: "OOPS",
      start: new Date("July 9, 2023 16:00"),
      finish: new Date("July 9, 2023 17:00"),
      authors: [
        {
          name: "Алексей Смирнов",
          position: "Founder Profiscope.io | CodeScoring",
        },
        {
          name: "Антон Бочкарев",
          position: "CEO 3side",
        },
        {
          name: "Дмитрий Куколев",
          position: "Директор по ИБ Дзен, VK",
        },
        {
          name: "Максим Залысин",
          position: "Head of DevOps Positive Technologies",
        },
      ],
    },
    {
      title:
        "Самые необычные и зрелищные кейсы взлома компаний, через соц инжиниринг",
      section: "OOPS",
      start: new Date("July 9, 2023 17:00"),
      finish: new Date("July 9, 2023 18:00"),
      authors: [
        {
          name: "Антон Бочкарев",
          position: "CEO 3side",
        },
      ],
    },
  ],
  4: [
    {
      title:
        "Засиделись: про тех, кто работает на одном месте по 10 лет подряд",
      section: "Комната страха",
      start: new Date("July 8, 2023 12:00"),
      finish: new Date("July 8, 2023 13:00"),
      authors: [
        {
          name: "Евгений Антонов",
          position: "TL Yandex Infrastructure",
        },
        {
          name: "Александр Субботин",
          position: "Руководитель разработки ContentAI",
        },
      ],
    },
    {
      title: "«… за гранью ТК РФ, или не ходите туда работать»",
      section: "Комната страха",
      start: new Date("July 8, 2023 13:00"),
      finish: new Date("July 8, 2023 14:00"),
      authors: [
        {
          name: "Анна Афонина",
          position: "Founder HiPoHeads, IT Recruiter SPb, ProIT Fest",
        },
      ],
    },
    {
      title: "Проработка Страхов от психолога",
      section: "Комната страха",
      start: new Date("July 8, 2023 14:00"),
      finish: new Date("July 8, 2023 15:00"),
      authors: [
        {
          name: "Евгений Идзиковский",
          position: "IT Психолог",
        },
      ],
    },
    {
      title: "Менеджерский АД",
      section: "Комната страха",
      start: new Date("July 8, 2023 15:00"),
      finish: new Date("July 8, 2023 16:00"),
      authors: [
        {
          name: "Константин Волков",
          position: "16 лет в IT",
        },
        {
          name: "Тарасов Алексей",
          position: "Зам. CTO Тинькофф Инвестиции",
        },
      ],
    },
    {
      title: "Data Сатанисты. Что мы делаем с вашими данными",
      section: "Комната страха",
      start: new Date("July 8, 2023 16:00"),
      finish: new Date("July 8, 2023 17:00"),
      authors: [
        {
          name: "Амир Утеуов",
          position: "Старший разработчик команды медиа-рекомендаций VK",
        },
        {
          name: "Никита Пустовойтов",
          position: "Data Science, ex-top-300 kaggle world",
        },
        {
          name: "Артур Сапрыкин",
          position:
            "Предприниматель, автор и преподаватель курсов по ML, founder Data Magic",
        },
      ],
    },
    {
      title: "Cтрашные заказчики",
      section: "Комната страха",
      start: new Date("July 8, 2023 17:00"),
      finish: new Date("July 8, 2023 17:30"),
      authors: [
        {
          name: "Яна Савельева",
          position: "Mentor UI/UX",
        },
        {
          name: "Карина Крашина",
          position: "Бизнес-консультант (ex.CEO Leacom)",
        },
      ],
    },
    {
      title: "Анонимные истории: Чего я боюсь в IT?",
      section: "Комната страха",
      start: new Date("July 8, 2023 17:30"),
      finish: new Date("July 8, 2023 18:00"),
      authors: [
        {
          name: "Виталий Полтавец",
          position: "Resource Manager Heads&Hands",
        },
      ],
    },
    {
      title: "Прокрастинация",
      section: "Help",
      start: new Date("July 9, 2023 12:00"),
      finish: new Date("July 9, 2023 13:00"),
      authors: [
        {
          name: "Евгений Идзиковский",
          position: "IT Психолог",
        },
      ],
    },
    {
      title: "Синдром самозванца",
      section: "Help",
      start: new Date("July 9, 2023 13:00"),
      finish: new Date("July 9, 2023 14:00"),
      authors: [
        {
          name: "Евгений Идзиковский",
          position: "IT Психолог",
        },
      ],
    },
    {
      title: "Всё для спины: Yoga, дыхание, медитация, гвозди",
      section: "Help",
      start: new Date("July 9, 2023 14:00"),
      finish: new Date("July 9, 2023 15:00"),
      authors: [
        {
          name: "Павел Машошин",
          position: "Тренер",
        },
      ],
    },
    {
      title: "Клуб анонимных выгоревших — BoF",
      section: "Help",
      start: new Date("July 9, 2023 16:00"),
      finish: new Date("July 9, 2023 17:00"),
      authors: [
        {
          name: "Яна Савельева",
          position: "Mentor UI/UX",
        },
      ],
    },
    {
      title: "Как перестать испытывать боль из-за нездоровой амбициозности",
      section: "Help",
      start: new Date("July 9, 2023 17:00"),
      finish: new Date("July 9, 2023 18:00"),
      authors: [
        {
          name: "Серафима Чекулаева",
          position: "Руководитель продукта Музыка ВКонтакте",
        },
      ],
    },
  ],
  5: [
    {
      title:
        "Хороший и хороший менеджер. Будь спокойным сегодня, а не идеальным завтра",
      section: "Management",
      start: new Date("July 8, 2023 12:00"),
      finish: new Date("July 8, 2023 13:00"),
      authors: [
        {
          name: "Эрик Бурыгин",
          position: "TL Yandex",
        },
        {
          name: "Виталий Качановский",
          position: "TL Иннотех",
        },
      ],
    },
    {
      title: "Антихрупкость в IT",
      section: "Management",
      start: new Date("July 8, 2023 13:00"),
      finish: new Date("July 8, 2023 14:00"),
      authors: [
        {
          name: "Александр Бындю",
          position: "Founder Byndyusoft",
        },
      ],
    },
    {
      title: "Внедрение нового: истории успеха и неуспеха",
      section: "Management",
      start: new Date("July 8, 2023 14:00"),
      finish: new Date("July 8, 2023 15:00"),
      authors: [
        {
          name: "Тимофей Нецветаев",
          position: "Head of DevOps/DBA CDEK",
        },
        {
          name: "Евгений Антонов",
          position: "Yandex Infrastructure",
        },
        {
          name: "Дмитрий Торшин",
          position: "Управляющий партнер UpLift",
        },
      ],
    },
    {
      title: "Один против всех, все против одного",
      section: "Management",
      start: new Date("July 8, 2023 15:00"),
      finish: new Date("July 8, 2023 16:00"),
      authors: [
        {
          name: "Маша Голдоберенкова",
          position: "Coach",
        },
        {
          name: "Евгений Фокин",
          position: "CTO Rockethumans",
        },
      ],
    },
    {
      title: "Практикум «Недирективное управление»",
      section: "Management",
      start: new Date("July 8, 2023 16:00"),
      finish: new Date("July 8, 2023 17:00"),
      authors: [
        {
          name: "Анастасия Абрашитова",
          position: "Head of repository tools Yandex Infrastructure",
        },
      ],
    },
    {
      title: "Социологические аспекты проведения организационных изменений",
      section: "Management",
      start: new Date("July 8, 2023 17:00"),
      finish: new Date("July 8, 2023 18:00"),
      authors: [
        {
          name: "Алексей Пименов",
          position: "Founder Neogenda",
        },
      ],
    },
    {
      title: "Введение. Описание секции и квеста",
      section: "Founder",
      start: new Date("July 9, 2023 12:00"),
      finish: new Date("July 9, 2023 12:20"),
      authors: [
        {
          name: "Виталий Янко",
          position: "Founder SPB Founders",
        },
      ],
    },
    {
      title: "Игра «Придумай идею и сделай MVP»",
      section: "Founder",
      start: new Date("July 9, 2023 12:20"),
      finish: new Date("July 9, 2023 13:00"),
      authors: [
        {
          name: "Михаил Кечинов",
          position: "IT-предприниматель",
        },
      ],
    },
    {
      title: "Почему я ещё не миллиардер?",
      section: "Founder",
      start: new Date("July 9, 2023 13:00"),
      finish: new Date("July 9, 2023 13:45"),
      authors: [
        {
          name: "Андрей Резепин",
          position: "Психолог, предприниматель в сфере IT и биотехнологиях",
        },
      ],
    },
    {
      title: "Фокусировка или как избежать ощущения адского достигаторства",
      section: "Founder",
      start: new Date("July 9, 2023 13:45"),
      finish: new Date("July 9, 2023 14:40"),
      authors: [
        {
          name: "Лидия Рогова",
          position: "Личный и групповой коуч",
        },
      ],
    },
    {
      title: "Станция: «Найми команду в ноунейм»",
      section: "Founder",
      start: new Date("July 9, 2023 15:20"),
      finish: new Date("July 9, 2023 16:20"),
      authors: [
        {
          name: "Валентин Домбровский",
          position: "Cооснователь Geekfactor.io и MoscowPython",
        },
        {
          name: "Анна Афонина",
          position: "Founder HiPoHeads",
        },
      ],
    },
    {
      title: "Станция: «Отбейся от конкурентов»",
      section: "Founder",
      start: new Date("July 9, 2023 16:20"),
      finish: new Date("July 9, 2023 17:40"),
      authors: [
        {
          name: "Никита Пустовойтов",
          position: "Data Science",
        },
      ],
    },
    {
      title: "Perfect питч на английском для бизнес-акселераторов",
      section: "Founder",
      start: new Date("July 9, 2023 17:40"),
      finish: new Date("July 9, 2023 18:00"),
      authors: [
        {
          name: "Соловей Анна",
          position: "Языковой коуч по английскому в IT",
        },
      ],
    },
  ],

  6: [
    {
      title: "Выставка ретро-компьютеров",
      section: "Front",
      start: new Date("July 8, 2023 12:00"),
      finish: new Date("July 8, 2023 18:00"),
      authors: [
        {
          name: "Retro Tech Squad",
          position: "",
        },
      ],
    },
    {
      title: "Эволюция подхода к адаптиву компонентов",
      section: "Front",
      start: new Date("July 8, 2023 12:00"),
      finish: new Date("July 8, 2023 13:00"),
      authors: [
        {
          name: "Серёжа Попов",
          position: "CPO Skillbox",
        },
      ],
    },
    {
      title:
        "Прогрессивный Яндекс Маркет: отдаём и оживляем контент по кусочкам",
      section: "Front",
      start: new Date("July 8, 2023 13:00"),
      finish: new Date("July 8, 2023 14:00"),
      authors: [
        {
          name: "Никита Сидоров",
          position: "Руководитель службы Яндекс Маркет",
        },
      ],
    },
    {
      title: "Асинхронность в JS. Почему так больно?",
      section: "Front",
      start: new Date("July 8, 2023 14:00"),
      finish: new Date("July 8, 2023 15:00"),
      authors: [
        {
          name: "Тимур Гафиулин",
          position: " TL Учи.ру",
        },
      ],
    },
    {
      title: "Микрофронты головного мозга",
      section: "Front",
      start: new Date("July 8, 2023 15:00"),
      finish: new Date("July 8, 2023 16:00"),
      authors: [
        {
          name: "Михаил Трифонов",
          position: "TL Cloud.ru",
        },
      ],
    },
    {
      title: "Рефлексия как метод проектирования архитектуры",
      section: "Front",
      start: new Date("July 8, 2023 16:00"),
      finish: new Date("July 8, 2023 17:00"),
      authors: [
        {
          name: "Глеб Михеев",
          position: "",
        },
      ],
    },
    {
      title: "Выгребаем техдолг из-под ковра",
      section: "Front",
      start: new Date("July 8, 2023 17:00"),
      finish: new Date("July 8, 2023 18:00"),
      authors: [
        {
          name: "Семен Левенсон",
          position: "TL Яндекс Маркет",
        },
      ],
    },
    {
      title: "Выставка ретро-компьютеров",
      section: "Back",
      start: new Date("July 9, 2023 12:00"),
      finish: new Date("July 9, 2023 18:00"),
      authors: [
        {
          name: "Retro Tech Squad",
          position: "",
        },
      ],
    },
    {
      section: "Back",
      title: "(Не)нужные акторы",
      start: new Date("July 9, 2023 12:00"),
      finish: new Date("July 9, 2023 13:00"),
      authors: [
        {
          name: "Андрей Парамонов",
          position: "TL Dodo Engineering",
        },
      ],
    },
    {
      title: "Reability, SLA",
      section: "Back",
      start: new Date("July 9, 2023 13:00"),
      finish: new Date("July 9, 2023 14:00"),
      authors: [
        {
          name: "Павел Лакосников",
          position: "PHP Lead Avito",
        },
      ],
    },
    {
      title: "Мнение о Profile-Guided Optimization в рамках большого проекта",
      section: "Back",
      start: new Date("July 9, 2023 14:00"),
      finish: new Date("July 9, 2023 15:00"),
      authors: [
        {
          name: "Никита Степанченко",
          position: "TL Zdravcity",
        },
      ],
    },
    {
      title: "Что я думаю о генериках",
      section: "Back",
      start: new Date("July 9, 2023 15:00"),
      finish: new Date("July 9, 2023 16:00"),
      authors: [
        {
          name: "Даниил Подольский",
          position: "Golang evangelist, Yadro",
        },
      ],
    },
    {
      title: "Внутренние облака: стек, архитектура, подход",
      section: "Back",
      start: new Date("July 9, 2023 16:00"),
      finish: new Date("July 9, 2023 17:00"),
      authors: [
        {
          name: "Алексей Шарапов",
          position: "CIO VK",
        },
      ],
    },
    {
      title: "Как документировать публичные API для продукта",
      section: "Back",
      start: new Date("July 9, 2023 17:00"),
      finish: new Date("July 9, 2023 18:00"),
      authors: [
        {
          name: "Андрей Кузнецов",
          position: "Архитектор Иннотех",
        },
      ],
    },
  ],

  7: [
    {
      title: "Тренды в digital-маркетинге для всех сфер",
      section: "Marketing",
      start: new Date("July 8, 2023 12:00"),
      finish: new Date("July 8, 2023 13:00"),
      authors: [
        {
          name: "Юля Тигай",
          position: "Digital стратег RealWeb",
        },
        {
          name: "Катя Подкопаева",
          position: "Директор по стратегическому планированию RealWeb",
        },
      ],
    },
    {
      title: "Креативные механики",
      section: "Marketing",
      start: new Date("July 8, 2023 13:00"),
      finish: new Date("July 8, 2023 14:00"),
      authors: [
        {
          name: "Лёша Мишенин",
          position: "Founder, креативный директор Штормскейп, Brainstore",
        },
      ],
    },
    {
      title: "Спиральная динамика: теория и применение в жизни и в работе",
      section: "Marketing",
      start: new Date("July 8, 2023 14:00"),
      finish: new Date("July 8, 2023 15:00"),
      authors: [
        {
          name: "Алена Гладышева",
          position: "Associate Creative Director Mate and Mate London",
        },
      ],
    },
    {
      title: "Особенности брендинга для IT компаний",
      section: "Marketing",
      start: new Date("July 8, 2023 15:00"),
      finish: new Date("July 8, 2023 16:00"),
      authors: [
        {
          name: "Женя Амонина",
          position: "СОО adelt.io",
        },
      ],
    },
    {
      title: "Мастер-класс по личному бренду",
      section: "Marketing",
      start: new Date("July 8, 2023 16:00"),
      finish: new Date("July 8, 2023 17:00"),
      authors: [
        {
          name: "Теххи Полонская",
          position: "Founder Брусника",
        },
        {
          name: "Лёша Мишенин",
          position: "Founder, креативный директор Штормскейп, Brainstore",
        },
      ],
    },
    {
      title:
        "Как развивать навыки общения, если не любишь публичные выступления?",
      section: "Marketing",
      start: new Date("July 8, 2023 17:00"),
      finish: new Date("July 8, 2023 18:00"),
      authors: [
        {
          name: "Егор Мыльников",
          position: "Ex-руководитель группы внутренних коммуникаций в Яндексе",
        },
      ],
    },
    {
      title: "Импровизация для IT-шников",
      section: "Мастерская",
      start: new Date("July 9, 2023 12:00"),
      finish: new Date("July 9, 2023 13:00"),
      authors: [
        {
          name: "Дмитрий Филиппов",
          position: "PM Kupsilla",
        },
        {
          name: "Артур Дементьев",
          position: "CTO",
        },
        {
          name: "Анастасия Абрашитова",
          position: "Yandex Infrastructure",
        },
      ],
    },
    {
      title: "Мастер класс: Умный дом своими руками",
      section: "Мастерская",
      start: new Date("July 9, 2023 13:00"),
      finish: new Date("July 9, 2023 14:00"),
      authors: [
        {
          name: "Андрей Логинов",
          position: "CTO A7 Systems",
        },
      ],
    },
    {
      title: "Как читать доклады: «7 лайфхаков успешной упаковки мыслей»",
      section: "Мастерская",
      start: new Date("July 9, 2023 14:00"),
      finish: new Date("July 9, 2023 15:00"),
      authors: [
        {
          name: "Лидия Урывская",
          position: "Тренер по публичным выступлениям, Ех-CEО",
        },
      ],
    },
    {
      title: "English for IT",
      section: "Мастерская",
      start: new Date("July 9, 2023 15:00"),
      finish: new Date("July 9, 2023 16:00"),
      authors: [
        {
          name: "Илья Круглов",
          position: "Work_Talk — speaking club",
        },
      ],
    },
    {
      title: "Трансформационная игра: «Драконий инкубатор»",
      section: "Мастерская",
      start: new Date("July 9, 2023 16:00"),
      finish: new Date("July 9, 2023 17:00"),
      authors: [
        {
          name: "Марина Арефьева",
          position:
            "Креативные Деловые Технологии. Стратегическое управление, agile coach",
        },
      ],
    },
    {
      title:
        "Клеточные автоматы в 2D и 3D с использованием библиотек p5.js и three.js",
      section: "Мастерская",
      start: new Date("July 9, 2023 17:00"),
      finish: new Date("July 9, 2023 18:00"),
      authors: [
        {
          name: "Степан Кухарский",
          position: "Партнёр архитектурной лаборатории SA Lab",
        },
      ],
    },
  ],

  8: [
    {
      title: "Мастер класс: Как не убить команду в софты.",
      section: "HR",
      start: new Date("July 8, 2023 12:00"),
      finish: new Date("July 8, 2023 13:00"),
      authors: [
        {
          name: "Дима Филлипов",
          position: "PM Kupsilla",
        },
      ],
    },
    {
      title:
        "Лекция и проработка кейсов участников. Офферы: Как закрыть кандидата за 2 звонка",
      section: "HR",
      start: new Date("July 8, 2023 13:00"),
      finish: new Date("July 8, 2023 14:00"),
      authors: [
        {
          name: "Саша Кузнецов",
          position: " TL IT Recruitment Daruma",
        },
      ],
    },
    {
      title: "Панельная дискуссия: TechBrand в условиях импортозамещения",
      section: "HR",
      start: new Date("July 8, 2023 14:00"),
      finish: new Date("July 8, 2023 15:00"),
      authors: [
        {
          name: "Виталий Охотников",
          position: "Lead DevRel RuStore/VK",
        },
        {
          name: "Александра Мин",
          position: "Директор по персоналу Мой.Офис",
        },
      ],
    },
    {
      title:
        "Мастер-класс / Игра: Синхронизация интересов сотрудника с интересами организации через геймификацию",
      section: "HR",
      start: new Date("July 8, 2023 15:00"),
      finish: new Date("July 8, 2023 16:00"),
      authors: [
        {
          name: "Дима Карпуничев",
          position: "Сo-Founder Loyal.gift",
        },
        {
          name: "Тамара Алмаметова",
          position: "HR Loyal.gift",
        },
      ],
    },
    {
      title: "Круглый стол: Жопа на рынке найма!",
      section: "HR",
      start: new Date("July 8, 2023 16:00"),
      finish: new Date("July 8, 2023 17:00"),
      authors: [
        {
          name: "Сережа Попов",
          position: "CPO Skillbox",
        },
        {
          name: "Анна Афонина",
          position: "Founder HiPoHeads",
        },
        {
          name: "Максим Терентьев",
          position: "Founder @mailfit @crmparty @letteros",
        },
        {
          name: "Павел Алексеев",
          position: "Яндекс.Практикум",
        },
      ],
    },
    {
      title: "Круглый стол: Между HR и Management — любовь или ненависть",
      section: "HR",
      start: new Date("July 8, 2023 17:00"),
      finish: new Date("July 8, 2023 17:80"),
      authors: [
        {
          name: "Евгений Антонов",
          position: "Yandex Infrastructure",
        },
        {
          name: "Михаил Кеченов",
          position: "Founder",
        },
        {
          name: "Виталий Янко",
          position: "SPB Founders",
        },
      ],
    },
    {
      title: "Мой любимый мем",
      desc: "Присылайте в t.me/proitfest_chat мемасики с тегом #mem_ProIT",
      section: "Смех",
      start: new Date("July 9, 2023 12:00"),
      finish: new Date("July 9, 2023 13:00"),
      authors: [
        {
          name: "",
          position: "",
        },
      ],
    },
    {
      title:
        "Ошибки капитального строительства как фактор информационной безопасности",
      section: "Смех",
      start: new Date("July 9, 2023 13:00"),
      finish: new Date("July 9, 2023 14:00"),
      authors: [
        {
          name: "Антон Жбанков",
          position: "Архитектор по ИТ инфраструктуре",
        },
      ],
    },
    {
      title: "IT Standup",
      section: "Смех",
      start: new Date("July 9, 2023 14:00"),
      finish: new Date("July 9, 2023 14:30"),
      authors: [
        {
          name: "Антон Назаров",
          position: "aka M0rtyMerr",
        },
      ],
    },
    {
      title: "Команда импровизации «Каждый с Каждым»",
      section: "Смех",
      start: new Date("July 9, 2023 14:30"),
      finish: new Date("July 9, 2023 15:00"),
      authors: [
        {
          name: "",
          position: "",
        },
      ],
    },
    {
      title: "Открытый микрофон",
      desc: "Готовы рассказать смешную историю или анекдот про IT? Заходите, у нас открыто!",
      section: "Смех",
      start: new Date("July 9, 2023 15:00"),
      finish: new Date("July 9, 2023 16:00"),
      authors: [
        {
          name: "",
          position: "",
        },
      ],
    },
    {
      title: "Формула сеньора: алкоголь и печеньки. Как алкоголь улучшает код",
      desc: "Важность правильного подбора напитков для разных стадий программирования",
      section: "Смех",
      start: new Date("July 9, 2023 16:00"),
      finish: new Date("July 9, 2023 17:00"),
      authors: [
        {
          name: "Андрей Логинов",
          position: "CTO A7 Systems",
        },
      ],
    },
    {
      title:
        "Стендап: Найми меня, если сможешь. Веселые истории собеседований разработчиков",
      section: "Смех",
      start: new Date("July 9, 2023 17:00"),
      finish: new Date("July 9, 2023 18:00"),
      authors: [
        {
          name: "Александра Прокшина",
          position: "Руководитель разработки юнита Avito",
        },
      ],
    },
  ],

  9: [
    {
      title: "Делимся опытом: Польза участия в Олимпиадах",
      section: "Geek",
      start: new Date("July 8, 2023 12:00"),
      finish: new Date("July 8, 2023 13:00"),
      authors: [
        {
          name: "Григорий Шовкопляс",
          position:
            "GShark — 5 лет координировал интернет Олимпиады по программированию",
        },
      ],
    },
    {
      title: "Делимся опытом: Польза участия в kaggle",
      section: "Geek",
      start: new Date("July 8, 2023 13:00"),
      finish: new Date("July 8, 2023 14:00"),
      authors: [
        {
          name: "Никита Пустовойтов",
          position: "Data Science, ex-top-300 kaggle world",
        },
      ],
    },
    {
      title: "Делимся опытом: Польза участия в хакатонах",
      section: "Geek",
      start: new Date("July 8, 2023 14:00"),
      finish: new Date("July 8, 2023 15:00"),
      authors: [
        {
          name: "Павел Алексеев",
          position: "Победитель хакатонов, наставник в Яндекс.Практикум",
        },
      ],
    },
    {
      title: "Обзор: Какие Open Source проекты выросли из Open Data Science?",
      section: "Geek",
      start: new Date("July 8, 2023 15:00"),
      finish: new Date("July 8, 2023 15:30"),
      authors: [
        {
          name: "Илья Виноградов",
          position: "ODS SPb",
        },
      ],
    },
    {
      title:
        "Делимся опытом: Способы привлечения финансов к FOSS проектам и почему с ними все плохо",
      section: "Geek",
      start: new Date("July 8, 2023 15:30"),
      finish: new Date("July 8, 2023 16:00"),
      authors: [
        {
          name: "Денис Пушкарев",
          position: "",
        },
      ],
    },
    {
      title: "Делимся опытом: Риски при выборе Open Source зависимостей",
      section: "Geek",
      start: new Date("July 8, 2023 16:00"),
      finish: new Date("July 8, 2023 16:30"),
      authors: [
        {
          name: "Алексей Смирнов",
          position: "Founder Profiscope.io | CodeScoring",
        },
      ],
    },
    {
      title: "Делимся опытом: История погружения в Open Source",
      section: "Geek",
      start: new Date("July 8, 2023 16:30"),
      finish: new Date("July 8, 2023 17:00"),
      authors: [
        {
          name: "Сергей Предводителев",
          position: "Core-team Yii",
        },
      ],
    },
    {
      title:
        "Lightning talks & Open Source beer-менторинг клуб-приносите свои GitHub проекты и пиво!",
      section: "Geek",
      start: new Date("July 8, 2023 17:00"),
      finish: new Date("July 8, 2023 18:00"),
      authors: [
        {
          name: "Никита Соболев",
          position: "",
        },
        {
          name: "Федор Борщев",
          position: "@pmdaily",
        },
        {
          name: "Валентин Ульянов",
          position: "",
        },
      ],
    },
    {
      title: "Шоукейсы от Gamedev House SPB",
      section: "Play Zone",
      start: new Date("July 9, 2023 12:00"),
      finish: new Date("July 9, 2023 18:00"),
      authors: [
        {
          name: "Филатов Ярослав",
          position: "Intronaunts Studio",
        },
      ],
    },
    {
      title: "Игра IT_codenames",
      section: "Play Zone",
      start: new Date("July 9, 2023 12:00"),
      finish: new Date("July 9, 2023 14:00"),
      authors: [
        {
          name: "Амир Утеуов",
          position: "Старший разработчик команды медиа-рекомендаций VK",
        },
      ],
    },
    {
      title: "Мафия",
      section: "Play Zone",
      start: new Date("July 9, 2023 14:00"),
      finish: new Date("July 9, 2023 16:00"),
      authors: [
        {
          name: "Егор Колобов",
          position: "MafiaPiter",
        },
      ],
    },
    {
      title: "DnD",
      section: "Play Zone",
      start: new Date("July 9, 2023 16:00"),
      finish: new Date("July 9, 2023 18:00"),
      authors: [
        {
          name: "Никита Степанченко",
          position: "TL Zdravcity",
        },
      ],
    },
  ],

  10: [
    {
      title: "Круглый стол: Мы никому не нужны",
      section: "Комната боли",
      start: new Date("July 8, 2023 12:00"),
      finish: new Date("July 8, 2023 13:00"),
      authors: [
        {
          name: "Никита Соболев",
          position: "Full-time Open Source",
        },
        {
          name: "Андрей Степенко",
          position: " IT когнитолог",
        },
      ],
    },
    {
      title: "Круглый стол: Без ТЗ результат ХЗ",
      section: "Комната боли",
      start: new Date("July 8, 2023 13:00"),
      finish: new Date("July 8, 2023 14:00"),
      authors: [
        {
          name: "Яна Савельева",
          position: "Mentor UI/UX",
        },
        {
          name: "Константин Хицко",
          position: "C++ TL, VK",
        },
        {
          name: "Карина Хашина",
          position: "PM",
        },
        {
          name: "Ольга Ермолаева",
          position: "QA Спортмастер Лаб",
        },
      ],
    },
    {
      title: "Практические кейсы безопасности разработки продуктов",
      section: "Комната боли",
      start: new Date("July 8, 2023 14:00"),
      finish: new Date("July 8, 2023 15:00"),
      authors: [
        {
          name: "Олег Коровин",
          position: "Head of Web Samokat.tech",
        },
        {
          name: "Максим Залысин",
          position: "Head of DevOps Positive Technologies",
        },
        {
          name: "Антон Бочкарев",
          position: "CEO 3side",
        },
        {
          name: "Дмитрий Кукколев",
          position: "Директор по ИБ Дзен, VK",
        },
      ],
    },
    {
      title: "Круглый стол: Велосипеды и Костыли",
      section: "Комната боли",
      start: new Date("July 8, 2023 15:00"),
      finish: new Date("July 8, 2023 16:00"),
      authors: [
        {
          name: "Александр Крылов",
          position: "TL DevOps",
        },
        {
          name: "Илья Кашлаков",
          position: "Head of Development YooMoney",
        },
        {
          name: "Антон Жбанков",
          position: "Архитектор по ИТ инфраструктуре",
        },
        {
          name: "Ольга Ермолаева",
          position: "QA Спортмастер Лаб",
        },
      ],
    },
    {
      title: "Проработка от психолога: Боль коммуникации",
      section: "Комната боли",
      start: new Date("July 8, 2023 16:00"),
      finish: new Date("July 8, 2023 17:00"),
      authors: [
        {
          name: "Евгений Идзиковский",
          position: "IT психолог",
        },
      ],
    },
    {
      title:
        "Дискуссионный доклад: «Боли разработки и менеджмента: честно о популярных ошибках и решениях»",
      section: "Комната боли",
      start: new Date("July 8, 2023 17:00"),
      finish: new Date("July 8, 2023 18:00"),
      authors: [
        {
          name: "Константин Щеглов",
          position: "CIO в SuperJob",
        },
      ],
    },
    {
      title: "Продажи vs разработка",
      section: "Fight",
      start: new Date("July 9, 2023 12:00"),
      finish: new Date("July 9, 2023 12:30"),
      authors: [
        {
          name: "Лидия Урывская",
          position: "Независимый бизнес-консультант",
        },
      ],
    },
    {
      title: "Kafka полезна?",
      section: "Fight",
      start: new Date("July 9, 2023 12:30"),
      finish: new Date("July 9, 2023 13:00"),
      authors: [
        {
          name: "Виктор Корейша",
          position: "OZON",
        },
        {
          name: "Филипп Дельгядо",
          position: "lekton.io",
        },
      ],
    },
    {
      title: "Суд над accessibility",
      section: "Fight",
      start: new Date("July 9, 2023 13:00"),
      finish: new Date("July 9, 2023 13:30"),
      authors: [
        {
          name: "Антон Крылов",
          position: "Senior Frontend Engineer в Avito",
        },
      ],
    },
    {
      title: "Дискуссия между участниками",
      desc: "Сюда отправляются те, кто начал спорить на других секциях",
      section: "Fight",
      start: new Date("July 9, 2023 13:30"),
      finish: new Date("July 9, 2023 14:00"),
      authors: [
        {
          name: "",
          position: "",
        },
      ],
    },
    {
      title: "Работа с госами, зашквар?",
      section: "Fight",
      start: new Date("July 9, 2023 14:00"),
      finish: new Date("July 9, 2023 14:30"),
      authors: [
        {
          name: "Анна Афонина",
          position: "HiPoHeads",
        },
        {
          name: "Тимур Алихманов",
          position: "Co-Founder StepUp",
        },
      ],
    },
    {
      title: "Дискуссия между участниками",
      desc: "Сюда отправляются те, кто начал спорить на других секциях",
      section: "Fight",
      start: new Date("July 9, 2023 14:30"),
      finish: new Date("July 9, 2023 15:00"),
      authors: [
        {
          name: "",
          position: "",
        },
      ],
    },
    {
      title: "DevOps инженеры умеют или не умеют в мониторинг и observability",
      desc: "Сюда отправляются те, кто начал спорить на других секциях",
      section: "Fight",
      start: new Date("July 9, 2023 15:00"),
      finish: new Date("July 9, 2023 16:00"),
      authors: [
        {
          name: "Александр Крылов",
          position: "TL DevOps",
        },
        {
          name: "Тихонов Дмитрий",
          position: "Ведущий Системный Инженер Иннотех",
        },
      ],
    },
    {
      title: "Какие доклады считать джуновскими, а какие нет?",

      section: "Fight",
      start: new Date("July 9, 2023 16:00"),
      finish: new Date("July 9, 2023 16:30"),
      authors: [
        {
          name: "Иван Политов",
          position: "Победитель розыгрыша Fight Club",
        },
        {
          name: "Максим Яцкевич",
          position: "Основатель Product Psychology",
        },
      ],
    },
    {
      title: "Дискуссия между участниками",
      desc: "Сюда отправляются те, кто начал спорить на других секциях",
      section: "Fight",
      start: new Date("July 9, 2023 16:30"),
      finish: new Date("July 9, 2023 17:00"),
      authors: [
        {
          name: "",
          position: "",
        },
      ],
    },
    {
      title: "Анти HR Brand",
      desc: "Говорим, в каких компаниях точно работать не будем",
      section: "Fight",
      start: new Date("July 9, 2023 13:30"),
      finish: new Date("July 9, 2023 14:00"),
      authors: [
        {
          name: "",
          position: "",
        },
      ],
    },
  ],

  robots: [
    {
      title: "Спортивная робототехника FIRST Tech Challenge",
      desc: "Можно поуправлять роботами и узнать подробнее об этом  направлении на практике",
      start: new Date("July 8, 2023 12:00"),
      section: "Роботы",

      finish: new Date("July 8, 2023 13:00"),
      authors: [
        {
          name: "",
          position: "",
        },
      ],
    },
  ],
  registration: [
    {
      title: "Регистрация участников фестиваля",
      section: "Регистрация",
      start: new Date("July 8, 2023 11:00"),
      finish: new Date("July 8, 2023 18:00"),
      authors: [
        {
          name: "",
          position: "",
        },
      ],
    },
    {
      title: "Лавка мерча",
      section: "Регистрация",
      start: new Date("July 8, 2023 11:00"),
      finish: new Date("July 8, 2023 18:00"),
      authors: [
        {
          name: "",
          position: "",
        },
      ],
    },
    {
      title: "Регистрация участников фестиваля",
      section: "Регистрация",
      start: new Date("July 9, 2023 11:00"),
      finish: new Date("July 9, 2023 18:00"),
      authors: [
        {
          name: "",
          position: "",
        },
      ],
    },
    {
      title: "Лавка мерча",
      section: "Регистрация",
      start: new Date("July 9, 2023 11:00"),
      finish: new Date("July 9, 2023 18:00"),
      authors: [
        {
          name: "",
          position: "",
        },
      ],
    },
  ],

  food: [
    {
      title: "DrinkUp: Мы все тестировщики",
      section: "Фудкорт",
      start: new Date("July 8, 2023 19:00"),
      finish: new Date("July 9, 2023 00:00"),
      authors: [
        {
          name: "Кира Кузнецова",
          position: "QA Drinkup",
        },
      ],
    },
    {
      title: "DrinkUp: Впечатляющие вопросы на собеседовании",
      section: "Фудкорт",
      start: new Date("July 8, 2023 19:00"),
      finish: new Date("July 9, 2023 00:00"),
      authors: [
        {
          name: "Аня Афонина",
          position: "IT Recruiter Drinkup",
        },
      ],
    },
    {
      title: "DrinkUp: Никакого IT",
      section: "Фудкорт",
      start: new Date("July 8, 2023 19:00"),
      finish: new Date("July 9, 2023 00:00"),

      authors: [
        {
          name: "Александр Коротаев",
          position: "Beer JS",
        },
      ],
    },
    {
      title: "DrinkUp: Golden Rules",
      section: "Фудкорт",
      start: new Date("July 8, 2023 19:00"),
      finish: new Date("July 9, 2023 00:00"),
      authors: [
        {
          name: "Евгения Ковалевская",
          position: "PMLUNCH",
        },
      ],
    },
    {
      title: "Факап истории",
      section: "Фудкорт",
      start: new Date("July 9, 2023 19:00"),
      finish: new Date("July 9, 2023 00:00"),
      authors: [
        {
          name: "Даниил Иванов",
          position: "Python Drinkup&bar hopping",
        },
      ],
    },
  ],
};

export default data;
